import {IBetWayWinData} from "@nolimitcity/slot-game/bin/utils/server/IData";
import {
    FeatureBuyTimesBetValue
} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

export enum WinTypes {
    TINY = "tiny",
    SMALL = "small",
    MEDIUM = "medium",
    LARGE = "large",
    BIG_WIN_01 = "bigWin01",
    BIG_WIN_02 = "bigWin02",
    BIG_WIN_03 = "bigWin03",
    BIG_WIN_04 = "bigWin04",
    BIG_WIN_05 = "bigWin05"
}

export interface xBombItem {
    indexOnSideReel: number;
    isLeftSideReel: boolean;
    toCoord: {
        x: number;
        y: number;
    };
}

export interface capItem {
    coord: {
        x: number;
        y: number;
    };
    isAwarded: boolean;
    sym: string;
    winTimesBet: number;
}

export interface IWinRatioConfig {
    readonly ratio: number;
    readonly duration: number;
    readonly type: string;
}

export interface IBigWinLevel extends IWinRatioConfig {
    readonly from: number;
    to: number;
    readonly id: number;
}

export interface IWinRatios {
    readonly normalWin: IWinRatioConfig[];
    readonly bigWin: IBigWinLevel[];
}

export interface HOTBData {
    mode: string;
    nextMode: string;
    reels: string[][]
    accumulatedRoundWin: number;
    reelTop: string[];
    reelTopAfterAvalanche: string[];
    reelLeft: string[];
    reelLeftNew: string[];
    reelRight: string[];
    reelRightNew: string[];
    deleteMap: boolean[][];
    nudgeMultipliers: number[];
    nudgeMultipliersCurrent: number[];
    nudgeMultipliersNext: number[];
    nudgeMultiplierBeforeSplit: number[];  //for initData
    nudgeMultipliersBeforeSplit: number[]; //for gameData
    launchMultiplierBeforeSplit: number[][];
    symbolMultipliers: number[][];
    betWayWins: IBetWayWinData[];
    evaluatedArea: string[][];
    symbolSizes: number[][];
    gameMultiplierAfter: number;
    freespinsLeft: number;
    nextPlayerInteraction?: IReplayNextPlayerInteraction;
    symbolsAfterAvalanche: string[][];
    symbolsAfterAvalanchePrevSpin: string[][];
    wasFeatureBuy: boolean;
    capSymbolList: capItem[];
    featureBuyName: string;
    spinRoundWin: number;
    boostedBetPlayed: boolean;
    playedBetValue: number;
}

export interface HOTBInitData extends HOTBData {
    isRestoreState: boolean;
    featureBuyTimesBetValue: FeatureBuyTimesBetValue[];
    symbolValues: ISymbolValues;
}

export interface HOTBGameData extends HOTBData {
    accumulatedRoundWin: number;
    totalSpinWinnings: number;
    brokeTheBank: boolean;
    xBombList: xBombItem[];
    waysWonTotalRound: number;
    numberOfFreespinsPlayed: number;
    fsUpgradeToSuper: boolean;
}

export interface ISymbolValues {
    [symbolName: string]: { [numSymbols: number]: number };
}

export interface IReplayNextPlayerInteraction {
    selectedIndex: number;
}